<template>
  <div class='text-center'>
    <!-- removed ' white' from class above to match sched week headers with table below (Note here in case I need to undo) - MJ -->
    <!-- is this used elsewhere other than the schedule?  Maybe need a background color prop? -->
    <v-divider class='mb-1'></v-divider>
    <span class='subtitle-1 font-weight-light'>
      <span :class="isToday ? 'font-weight-bold' : ''">{{ title }}</span>
    </span>
    <br>
    <v-btn
      small
      text
      color='primary'
      :class="isToday ? 'font-weight-bold text-uppercase subtitle-1 mt-n2' : 'text-uppercase subtitle-1 mt-n2'"
      @click='openDayView'
    >
      {{ subtitle }}
    </v-btn>
    <v-divider class='mt-1'></v-divider>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'day-header',
  props: {
    date: {
      required: true
    }
  },
  computed: {
    title () {
      if (moment(this.date).format('D').toString() === '1') {
        return moment(this.date).format('MMMM D')
      }
      return moment(this.date).format('D')
    },
    subtitle () {
      return moment(this.date).format('dddd')
    },
    isToday () {
      return moment(this.date).isSame(moment(), 'day')
    }
  },
  methods: {
    openDayView () {
      this.$emit('clearScheduleData')
      this.$router.push({ name: 'ScheduleDay', params: { id: this.$route.params.id, date: this.date } })
    }
  }
}
</script>
